import { defineMessages } from 'react-intl'

export default defineMessages({
    unAvailabilityAndBookings: {
        id: 'containers.SupplierPage.Availability.unAvailabilityAndBookings',
        defaultMessage: 'Un-availability and bookings',
    },
    unAvailabilityAndBookingsDescription: {
        id: 'containers.SupplierPage.Availability.unAvailabilityAndBookingsDescription',
        defaultMessage: 'Registered un-availability and bookings for the supplier',
    }
})
